/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D button
 */

import React from "react";
import PropTypes from "prop-types";

const Spinner = React.memo(({ radius, arc = 320, color = "#7fefe0", ...otherAttributes }) => {
    return (
        <a-entity class="Spinner" {...otherAttributes}>
            <a-torus
                radius={radius}
                radius-tubular={radius * 0.1}
                arc={arc}
                color={color}
                animation__rotate="property: rotation; from: 0 0 0; to: 0 0 360; loop: true; dur: 1500; easing: linear"
            />
        </a-entity>
    );
});

Spinner.propTypes = {
    radius: PropTypes.number.isRequired
};

export default Spinner;
